import React from 'react';
import App from './App';
import ExternalApp from './ExternalApp';
import { useApp } from './appContext';
import { hasCustomerSession } from './portal/customerSession';
import { NavGuardProvider } from './unsavedChangesGuard';

// Picks the internal shell or the customer shell based on what GET /auth/me returned --
// ExternalPrincipal responses carry `isExternal: true` (apps/api/src/auth/auth.service.ts);
// internal User rows never have that field. Lives between MaintenanceGate and the two shells
// (index.js) rather than inside App.js, so App.js stays exactly what it was before the customer
// portal existed.
//
// The local-session check is a second, independent reason to choose the customer shell, and it
// exists because `currentUser` is not always populated when this renders: MaintenanceGate
// deliberately fails OPEN when /auth/me is unreachable, which would otherwise drop a signed-in
// customer into the internal App -- internal nav, internal-only endpoints, and a Sign out button
// calling into msal-react's stubbed context, since the portal tree has no MsalProvider.
export default function AppShell() {
  const { currentUser } = useApp();
  const isCustomer = currentUser?.isExternal || hasCustomerSession();
  // Only the internal shell has write affordances to guard (the customer portal's registers are
  // read-only) -- wrapped here, not inside App.js itself, so App's own body is a real descendant and
  // every hook call in it (side nav, Sign out, Maintenance) resolves against this provider directly.
  return isCustomer ? <ExternalApp /> : <NavGuardProvider><App /></NavGuardProvider>;
}
